import React, { useContext } from 'react';
import { AuthContext, AuthContextType } from 'Contexts/AuthContext';
import Login from 'App/Auth/Screens/Login/Login';

// SSO entry for the satellite apps (?auth=<key>, see EXTERNAL_AUTH_TARGETS): same
// form as /auth/login, AuthContext hands the token to the target after sign-in.
const LoginWithGastronautContainer = () => {
  const { signInUser, user, retryProfileCheck } = useContext<AuthContextType>(AuthContext);

  return <Login onSignIn={signInUser} notice={user.notice} onRetryProfile={retryProfileCheck} />;
};

export default LoginWithGastronautContainer;
